import React from 'react'
import { Modal ,Row ,Col,Container } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import ErrorHandler from "../../error-handler/ErrorHandler";
import axiosInstance from "../../api/axiosInstance";

const DeleteModal = ({ show , modalHeader, hide, cancel ,url}) => {

    const { t } = useTranslation();
    const deleteItem = async ()=>{
        let result = await axiosInstance.delete(url)
        
        if(result){
            hide()
        }
    }
    return (
        <Modal show={show}>
            <Container className="p-4">
            <Row>
                <Col className="text-center" sm={12}>
                    {" "}
                    <h6 style={{ fontWeight: "600" }}>{modalHeader}</h6>
                </Col>
            </Row>
            <Row style={{ margin: "auto" }}>
                <Col className="text-center" md={12}>
                    <button onClick={deleteItem} className="rejectBtn mx-3">
                        {t("unverifiedTable.delete")}
                    </button>
                    <button className="cancelBtn" onClick={cancel}>
                        {t("unverifiedTable.cancel")}
                    </button>
                </Col>
            </Row>
            </Container>
        </Modal>
    )
}

export default ErrorHandler(DeleteModal , axiosInstance) 